var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vista-cargando__container"},[_c('svg-icon',{attrs:{"width":"auto","height":"7.5rem","src":require('../assets/logo.svg')}}),_c('svg-icon',{attrs:{"color":"#ffffff","width":"5.25rem","height":"5.25rem","name":"ld-circle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }